/**
 * O slug do projeto de uma organização (A2, spec 2026-10-08 §4): vira o nome da conta na AWS e o
 * endereço do projeto, e não muda depois. Compartilhado pela tela admin e pelo modal do Pedido de
 * Nova Organização (spec 2026-10-27 §4.4).
 */
import type { ReactNode } from 'react'
import { Stack, Text, TextInput } from '@mantine/core'

// A regra é a mesma do backend (`SLUG_PROJETO_NOVO_REGEX`); o backend confere de novo e decide.
export const SLUG_PROJETO = /^[a-z][a-z0-9]*(?:-[a-z0-9]+)*$/
const DOMINIO_MAE = 'amazonasinovare.com.br'

/** O slug sugerido a partir do nome, como o `_make_slug` do backend (`organization_service.py`):
 *  NFKD, só ASCII, minúsculas, e um hífen no lugar de cada trecho que não é letra ou dígito. */
export function slugDoNome(nome: string): string {
  return nome
    .normalize('NFKD')
    .replace(/[\u0080-\uffff]/g, '')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
}

interface Props {
  valor: string
  onChange: (v: string) => void
  /** O que dizer abaixo do slug válido. Sem isto: a conta e a zona que serão criadas. */
  aviso?: ReactNode
}

export function CampoSlugDoProjeto({ valor, onChange, aviso }: Props) {
  const valido = SLUG_PROJETO.test(valor)
  return (
    <Stack gap={4}>
      <TextInput
        label="Slug do projeto"
        value={valor}
        onChange={(e) => onChange(e.currentTarget.value)}
        error={valor && !valido ? 'Use minúsculas, dígitos e um hífen entre palavras, começando por letra' : undefined}
      />
      {valido && (
        <Text size="xs" c="dimmed">
          {aviso ?? (
            <>
              Será criada a conta {valor}-prd e a zona {valor.replace(/-/g, '')}.{DOMINIO_MAE}. O slug não muda depois.
            </>
          )}
        </Text>
      )}
    </Stack>
  )
}
